<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-top-transition"
    max-width="600"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="botao_1"
        class="rounded-lg"
        v-bind="attrs"
        v-on="on"
        dark
        text
        >ALTERAR SENHA</v-btn
      >
    </template>

    <v-card class="rounded-lg">
      <v-toolbar dark class="rounded-lg" color="primary">
        Alterar Senha
      </v-toolbar>

      <br />

      <v-card-text>
        <v-alert
            v-if="msg"
            type="error"
        >{{ msg }}</v-alert>

        <v-form ref="form">
          <v-text-field
            v-model.trim="form.senha_atual"
            label="Senha Atual"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :rules="[rules.obrigatorio, rules.min_8]"
            :counter="8"
            :maxlength="8"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

          <v-text-field
            v-model.trim="form.senha_nova"
            label="Nova Senha"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :rules="[rules.obrigatorio, rules.min_8]"
            :counter="8"
            :maxlength="8"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

          <v-text-field
            v-model.trim="form.repita_senha_nova"
            label="Repita a Nova Senha"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :rules="[rules.obrigatorio, rules.min_8,
                    (v) => v==form.senha_nova || 'As novas senhas devem ser iguais']"
            :counter="8"
            :maxlength="8"
            clear-icon="mdi-close-circle"
            clearable
          ></v-text-field>

        </v-form>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text @click="dialog = false"> Cancelar </v-btn>
        <v-btn text @click="salvar(form)"> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/services/api";
import verifica_token_storage from "@/utils/verifica_token_storage";
import { mapMutations } from "vuex";

export default {
  name: "NovoLembrete",

  data: () => ({
    dialog: false,
    tipo_input: "password",
    form: {
        senha_atual: "",
        senha_nova: "",
        repita_senha_nova: "",
    },
    show: false,
    msg: null,
    rules: {
      obrigatorio: (v) => !!v || "Este campo é obrigatório",
      min_8: (v) => v.length >= 8 || 'Mínimo 8 caracteres'
    },
  }),

  methods: {
    ...mapMutations(["CarregandoMutation"]),

    salvar(form) {
      if (this.$refs.form.validate()) {
        this.CarregandoMutation();
        const headers = verifica_token_storage();

        api
          .put("perfil/", form, { headers })
          .then((response) => {
            const response_data = response.data

            if(response_data.status=='ok'){
                this.$emit("form-submit");
                
                // Resetar
                this.dialog = false;
                this.form = {};
            } else {
                this.msg = response_data.msg
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.CarregandoMutation();
          })
      }
    },
  },
};
</script>
